var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"am-tabs-arrow"},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"mdc-button__ripple"}),_c('am-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }